/**
 * SaGó · un «Añadir» cada vez en las tarjetas del cajón.
 *
 * Medido el 22/09: pulsar las dos tarjetas de «Se suele pedir con esto»
 * seguidas (a ~150 ms, normal en el móvil) PERDÍA la primera alta en 3 de 8
 * pasadas. Shopify respondía bien a las dos y product-form.js publicaba las
 * dos, pero en /cart.js sólo quedaba la segunda. La página no hacía ninguna
 * otra escritura al carrito (registradas todas, fetch y XHR): el servidor se
 * queda con la última cuando dos altas desde el navegador se solapan. Con
 * curl no se reproduce.
 *
 * Así que mientras una alta de una tarjeta está en marcha, las demás tarjetas
 * del cajón quedan desactivadas (aria-disabled: product-form.js las ignora y
 * se ven atenuadas) y un segundo envío se descarta antes de que llegue a
 * product-form.js. Se liberan cuando Shopify confirma o rechaza el alta, y a
 * los 10 s si no contesta. Vale también para «Los más pedidos» del cajón
 * vacío, que tiene dos «Añadir» juntos.
 *
 * Se carga ANTES que sago-recs-eventos.js: su escucha de `submit` va antes y
 * un envío descartado no llega a apuntarse como clic.
 */
(() => {
  if (window.sagoCajonAnadir) return;
  window.sagoCajonAnadir = true;

  const cajon = document.querySelector('cart-drawer');
  if (!cajon) return;

  let enVuelo = false;
  let reloj = null;

  const botones = () => cajon.querySelectorAll('.sago-tarjeta__boton');

  const bloquear = () => {
    botones().forEach((b) => {
      if (!b.classList.contains('loading')) b.setAttribute('aria-disabled', 'true');
    });
  };

  const liberar = () => {
    clearTimeout(reloj);
    if (!enVuelo) return;
    enVuelo = false;
    botones().forEach((b) => {
      if (!b.classList.contains('loading')) b.removeAttribute('aria-disabled');
    });
  };

  document.addEventListener(
    'submit',
    (ev) => {
      const form = ev.target;
      if (!form || !form.closest || !form.closest('#CartDrawer .sago-tarjeta')) return;
      if (enVuelo) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        return;
      }
      enVuelo = true;
      // Después de que product-form.js ponga su propio botón en «cargando».
      setTimeout(bloquear);
      clearTimeout(reloj);
      reloj = setTimeout(liberar, 10000);
    },
    true
  );

  // Sólo la respuesta de un «Añadir»: cart-update lo publican también el
  // calendario y los cambios de cantidad, y liberar con ellos abriría el hueco.
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  const alResponder = (ev) => {
    try {
      if (ev && ev.source === 'product-form') liberar();
    } catch (e) {}
  };
  subscribe(PUB_SUB_EVENTS.cartUpdate, alResponder);
  subscribe(PUB_SUB_EVENTS.cartError, alResponder);
})();
